import env from '@/env'
import ENV from '@/env/ENV'

const config = {
  rootURL: ENV[env].rootURL,
  apiBase: `${ENV[env].rootURL}/wp-json/api/v1`,
  eventsApiBase: `${ENV[env].rootURL}/wp-json/tribe/events/v1`,
  authURI: `${ENV[env].rootURL}/oauth/token`,
  clientID: ENV[env].clientID,
  responseType: 'token',
  tokenName: 'abilibeeToken',
}

const authRedirect = `${config.authURI}?client_id=${config.clientID}&response_type=${config.responseType}`

export default config
export { authRedirect }
